import {
  chatBreadcrumbs,
  ifAuthenticated,
  profileSettingsBreadcrumbs,
  requestVisitBreadcrumbs,
  visitCenterArchiveBreadcrumbs,
  visitCenterUpcomingBreadcrumbs,
} from "./utils";

const patientRoutes = [
  {
    path: "/patient",
    name: "patientHome",
    component: (): unknown => import("@/views/Patient/View.vue"),
    meta: {
      authorize: ["patient"],
    },
    redirect: "/patient/encounters/",
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: "chat",
        name: "patientChat",
        meta: { breadcrumbs: chatBreadcrumbs },
        component: (): unknown => import("@/views/Patient/Chat/Index.vue"),
      },
      {
        path: "settings",
        name: "patientSettings",
        component: (): unknown => import("@/views/Patient/Settings.vue"),
        meta: { breadcrumbs: profileSettingsBreadcrumbs },
      },
      {
        path: "visits",
        component: (): unknown => import("@/views/Patient/Appointments/View.vue"),
        redirect: "/patient/visits/upcoming/",
        children: [
          {
            path: "upcoming",
            component: (): unknown => import("@/views/Patient/Appointments/Upcoming.vue"),
            meta: { breadcrumbs: visitCenterUpcomingBreadcrumbs, layout: "default" },
          },
          {
            path: "archive",
            component: (): unknown => import("@/views/Patient/Appointments/Archive.vue"),
            meta: { breadcrumbs: visitCenterArchiveBreadcrumbs, layout: "default" },
          },
        ],
      },
      {
        path: "encounters",
        component: (): unknown => import("@/views/MiddleComponent.vue"),
        redirect: "/patient/visits/upcoming",
        children: [
          {
            path: "schedule",
            component: (): unknown => import("@/views/Patient/Visits/Request.vue"),
            meta: { breadcrumbs: requestVisitBreadcrumbs },
          },
          {
            path: "schedule/:sessionId/:status",
            name: "patientCheckoutComplete",
            component: (): unknown => import("@/views/Patient/Visits/Request.vue"),
            meta: { breadcrumbs: requestVisitBreadcrumbs },
          },
          {
            path: ":encounterId",
            component: (): unknown => import("@/views/Patient/Visits/Call.vue"),
            name: "PatientEncounter",
            meta: { collapseSidebar: true, hideNav: true },
          },
          {
            path: ":encounterId/summary",
            component: (): unknown => import("@/views/Patient/Visits/Summary.vue"),
            meta: { collapseSidebar: true },
          },
        ],
      },
    ],
  },
];
export default patientRoutes;
